<script setup lang="ts">
import { useI18n } from 'petite-vue-i18n';
import { TEXT } from '../../../configs/text';
import { VocabResult, VocabResultDecision } from '../../../types/session';
import localforage from 'localforage';
import { computed, onMounted, ref } from 'vue';
import AudioPlayer from '../../General/AudioPlayer.vue';
import { ArrowPathIcon, PlayIcon } from '@heroicons/vue/16/solid';



const { result } = defineProps<{ result: VocabResult }>()
const audioUrl = ref<string>('')
const { t } = useI18n()

function icon(isLoading: boolean) {
    if (isLoading) return ArrowPathIcon;
    return PlayIcon
}

const highlightedSentence = computed(() => {
    const charStyles: string[] = Array(result.sentence.length).fill("")
    result.words.forEach(word => {
        word.phonemes?.forEach((ph: any) => {
            const color = getTextColor(ph.decision)
            for (let i = ph.start_index; i <= ph.end_index; i++) {
                charStyles[i] = color
            }
        })
    })

    return result.sentence
        .split("")
        .map((ch, i) => {
            if (charStyles[i]) {
                return `<span class="${charStyles[i]}">${ch}</span>`
            }
            return ch
        })
        .join("")
})

function getTextColor(decision: VocabResultDecision): string {
    switch (decision) {
        case VocabResultDecision.correct:
            return 'text-lime-500';
        case VocabResultDecision.warning:
            return 'text-yellow-500';
        case VocabResultDecision.incorrect:
            return 'text-orange-600';
        default:
            return '';
    }
}

onMounted(async () => {
    const audioBlob = await localforage.getItem<Blob>(result.key || '')
    audioUrl.value = audioBlob ? URL.createObjectURL(audioBlob) : ''
})

</script>
<template>
    <div class="flex flex-col items-center gap-3 w-full">
        <div class="w-full text-center font-bold text-2xl" v-html="highlightedSentence"></div>
        <AudioPlayer v-if="audioUrl" :src="audioUrl">
            <template #button="{ isLoading }">
                <div class="flex items-center justify-center gap-2 box-content border border-b-4 px-4 py-2 rounded-2xl cursor-pointer relative overflow-hidden text-white bg-sky-500 border-sky-700">
                    <component :is="icon(isLoading)" class="size-5 fill-white pointer-events-none" :class="{ 'animate-spin': isLoading }" />
                    <span>{{ t(TEXT.your_record) }}</span>
                </div>
            </template>
        </AudioPlayer>
    </div>
</template>